import { Flex } from 'antd';

import Page from '../../components/Page/Page';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import SeamlessLogisticService from './SeamlessLogisticService/SeamlessLogisticService';
import ShipmentMadeFaster from './ShipmentMadeFaster/ShipmentMadeFaster';
import SimplifiedLogistic from './SimplifiedLogistic/SimplifiedLogistic';
import Hero from './Hero/Hero';
import TrackingSection from './TrackingSection/TrackingSection';
import PartneredWithSection from './PartneredWithSection/PartneredWithSection';

const Home = () => {
  return (
    <Page title='CML | Home'>
      <Flex vertical>
        <Hero />
        <TrackingSection />
        <SeamlessLogisticService />
        <SimplifiedLogistic />
        {/* <SameDayDelivery /> */}
        <ShipmentMadeFaster />
        <PartneredWithSection />
        <FrequentlyAskedQuestions />
      </Flex>
    </Page>
  );
};

export default Home;
